import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { IPrimaryKey } from "~app/common/services/cqs/IPrimaryKey";

export abstract class ArbetsorderHandelssortimentBaseCommand extends BasicCommand<ArbetsorderHandelssortimentBaseCommand> {
    handelssortimentId: number;
    arbetsorderId: number;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $groupKey = "ArbetsorderHandelssortiment";
    get primaryKey(): IPrimaryKey<IArbetsorderHandelssortimentPrimaryKey> {
        return {
            arbetsorderId: this.arbetsorderId,
            handelssortimentId: this.handelssortimentId
        };
    }
    constructor($type, commandType) {
        super($type, ArbetsorderHandelssortimentBaseCommand.$groupKey, commandType);
    }
}

export interface IArbetsorderHandelssortimentPrimaryKey {
    arbetsorderId: number;
    handelssortimentId: number;
}
